import { AbstractProductItemOrderEstimate } from '../abstract-product-item-order-estimate.model';
import { ProductItemPersonalization } from '../product-item-personalization';

export class ProductItemOrderEstimate extends AbstractProductItemOrderEstimate {
  personalization: ProductItemPersonalization;
}
